import { defineComponent, h } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import arrayExpressionMixin from './arrayExpressionField.jsx';
import utils from '../../../Shared/utils.jsx';
import { appSettings } from '@/Shared/appSettings.js';

import TranslationContainer from './../TranslationContainer.jsx';
import { QSelect } from 'quasar';

export default defineComponent({
    name: 'sform-tags',
    mixins: [BaseComponent, arrayExpressionMixin],
    components: {
        TranslationContainer
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        //if (this.autofocus)
        //    setTimeout(() => {
        //        const item = this.$refs[this.autofocus_id];
        //        if (item) {
        //            this.$refs[this.autofocus_id].focus();

        //            let inputEl = this.$refs[this.autofocus_id].$el.querySelector('input');
        //            inputEl.select();

        //            //this.input = 'test value'
        //            setTimeout(() => {
        //                inputEl.select();
        //            }, 200);
        //        }
        //    }, 250);

        this.loadComplete();
    },
    computed: {
    },
    methods: {
    },
    render() {
        const expression = this.renderArrayExpressionStandIn({ class: 'c-formTags', labelSlot: true });
        if (expression)
            return expression;

        let slots = {
            hint: ({ hint }) => { 
                return <TranslationContainer context={this} value={hint}></TranslationContainer>
            },
        };
        if (this.hasInputLabel)
            slots.label = () => <TranslationContainer context={this} value={this.labelText}></TranslationContainer>;

        let input =
            <QSelect
                ref={this.autofocus ? this.autofocus_id : undefined}
                outlined
                dense
                style={{ width: "100%" }}
        
                useInput
                useChips
                multiple
                newValueMode="add-unique"

                label={this.inputLabel} 
                stackLabel={this.hasInputLabel && this.itemvalue && this.itemvalue.length > 0}
        
                modelValue={this.itemvalue}
                prefix={this.element?.fieldAddonLeft}
                hint={this.inputHint}
                hide-hint
                persistent-hint={!!appSettings.DebugTranslationPrefixSetting}
                hideDetails={!this.hintText && !this.rules}
                bottom-slots={!!this.hintText || !!(this.rules && this.rules.length > 0)}
                rules={this.rules} {...this.compilerErrorFieldProps}

                onUpdate:modelValue={(value) => { this.sync(value); }}
                onFocus={() => { this.onFocus(); }}
                onBlur={() => { this.onBlur(); }}
            >
            {slots}
        </QSelect>;

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);
        //input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        if (this.autofocus)
            input.props.autofocus = true;

        return input;
    }
});